import React from 'react';
import autoBind from 'auto-bind';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Header, Button, Icon } from 'semantic-ui-react';
import { SemanticToastContainer } from 'react-semantic-toasts';
import {
  getHardwareProducts,
  getHardwareBaseProducts,
  showCreateHardwareModal,
  showEditHardwareModal,
  showDeleteHardwareConfirmation,
  doShowLogs,
  setLogModalShown,
  setLogPage,
} from 'state/hardwareCatalogue/actions';
import HardwareTable from 'pages/HardwareCatalogue/HardwareTable';
import RegisterHardwareModal from 'pages/HardwareCatalogue/RegisterHardwareModal';
import DeleteHardwareConfirmationModal from 'pages/HardwareCatalogue/DeleteHardwareConfirmationModal';
import LogModal from 'components/LogModal';

export class HardwareCataloguePage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getHardwareProducts());
    dispatch(getHardwareBaseProducts());
  }

  onRegisterHardwareClicked() {
    const { dispatch } = this.props;
    dispatch(showCreateHardwareModal(true));
  }

  onEditHardwareClicked(productData) {
    const { dispatch } = this.props;
    dispatch(showEditHardwareModal(true, productData));
  }

  onDeleteHardwareClicked(productData) {
    const { dispatch } = this.props;
    dispatch(showDeleteHardwareConfirmation(true, productData));
  }

  onShowLogsClicked() {
    const { dispatch } = this.props;
    dispatch(doShowLogs());
  }

  render() {
    const { products, isLoading, dispatch, log } = this.props;

    return (
      <Container style={{ marginTop: '2em' }}>
        <SemanticToastContainer position="top-right" />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '1em',
          }}
        >
          <div>
            <Header as="h1" style={{ marginBottom: '0.2em' }}>
              Hardware Catalogue
            </Header>
            <p style={{ color: '#666', margin: 0 }}>
              Manage hardware items, pricing, and availability for quotations
            </p>
          </div>
          <Button
            primary
            icon
            labelPosition="left"
            onClick={this.onRegisterHardwareClicked}
          >
            <Icon name="plus" />
            Register Hardware
          </Button>
        </div>

        <Button basic color="black" onClick={this.onShowLogsClicked}>
          Show Logs
        </Button>

        <HardwareTable
          products={products}
          isLoading={isLoading}
          onEdit={this.onEditHardwareClicked}
          onDelete={this.onDeleteHardwareClicked}
        />

        <RegisterHardwareModal />
        <DeleteHardwareConfirmationModal />
        <LogModal
          title="Hardware Catalogue Logs"
          shown={log.shown}
          data={log.data}
          paging={log.paging}
          isLoading={log.isLoading}
          errors={log.errors}
          onPageChange={page => dispatch(setLogPage(page))}
          onClose={() => dispatch(setLogModalShown(false))}
        />
      </Container>
    );
  }
}

HardwareCataloguePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  products: PropTypes.array,
  isLoading: PropTypes.bool,
  log: PropTypes.shape({
    shown: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    paging: PropTypes.shape({
      page: PropTypes.number.isRequired,
      size: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
    }).isRequired,
    isLoading: PropTypes.bool.isRequired,
    errors: PropTypes.array.isRequired,
  }).isRequired,
};

HardwareCataloguePage.defaultProps = {
  products: [],
  isLoading: false,
};

const mapStateToProps = state => ({
  products: state.hardwareCatalogue.products,
  isLoading: state.hardwareCatalogue.isLoading,
  log: state.hardwareCatalogue.log,
});

export default connect(mapStateToProps)(HardwareCataloguePage);
